export default __webpack_public_path__ + "static/pdl-83c9aa7f24299eb528b1c2d8dd4e9f50.png";